var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{directives:[{name:"close-popover",rawName:"v-close-popover"}],attrs:{"width":"20px","src":require("../../assets/images/Group 40@2x.png")},on:{"click":function($event){return _vm.$emit('click', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }